import { selfAxios } from "../../../../../axios/selfAxios.js";
async function getCrmCustomerTelDecrypt(params) {
  const { data } = await selfAxios.get(`/crm/customer/tel/decrypt`, { params });
  return data;
}
export { getCrmCustomerTelDecrypt };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/crm/customer/tel/decrypt/get.js